<template>
    <mounting-portal mount-to="#portalvue-audio-article">
        <div>
            <div
                class="container mx-auto  xl:px-0 flex flex-row-reverse flex-wrap px-5 md:px-0"
                :class="[{ ' -mb-3': lite }, { 'mb-10': !lite }]"
            >
                <div
                    :class="[
                        'px-6 py-3 rounded-lg',
                        { 'bg-whiteish px-6 py-3 rounded-lg': !lite }
                    ]"
                >
                    <div class="flex items-center gap-2">
                        <button @click="togglePlay" class="group mt-1">
                            <svg
                                class="text-gray-800 w-6 h-6 group-hover:scale-125 transform transition duration-300"
                                viewBox="0 0 50 50"
                                xmlns="http://www.w3.org/2000/svg"
                                v-if="!playing"
                            >
                                <path
                                    d="M20.534,37.374a1.774,1.774,0,0,1-.817-.2,1.813,1.813,0,0,1-.967-1.611V17.437a1.81,1.81,0,0,1,.967-1.61,1.774,1.774,0,0,1,.817-.2,1.756,1.756,0,0,1,1.035.336l12.493,9.063a1.828,1.828,0,0,1,0,2.95L21.57,37.039A1.759,1.759,0,0,1,20.534,37.374Z"
                                    fill="#fff"
                                    data-name="Subtraction 1"
                                    id="Subtraction_1"
                                    transform="translate(-0.75 -1.626)"
                                ></path>
                                <path
                                    d="M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25ZM21.219,15.916a1.563,1.563,0,0,0-2.469,1.272V32.813a1.562,1.562,0,0,0,2.469,1.272l10.938-7.812a1.562,1.562,0,0,0,0-2.544L21.219,15.916Z"
                                    fill="currentColor"
                                    id="play"
                                    transform="translate(0 0)"
                                ></path>
                            </svg>

                            <div
                                class="bg-gray-800 p-1 rounded-full group-hover:scale-125 transform transition duration-300"
                                v-else
                            >
                                <svg
                                    class="text-white w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <rect
                                        width="12.5"
                                        height="12.5"
                                        x="5.75"
                                        y="5.75"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                        rx="1"
                                    ></rect>
                                </svg>
                            </div>
                        </button>

                        <div class="flex flex-col">
                            <div class="pt-2 text-gray-800 text-sm font-medium">
                                Play Audio News
                            </div>
                            <div
                                class="text-gray-500 font-medium"
                                style="font-size: 10px;"
                            >
                                Powered By Javaabu
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="lg:left-112 xl:left-120 fixed inset-x-0 bottom-0 z-10"
                v-show="playing"
            >
                <div
                    class="flex items-center gap-6 bg-white py-4 px-4 shadow shadow-gray-200 ring-1 ring-gray-900 md:px-6 opacity-95 relative"
                >
                    <button
                        class="absolute top-0 right-0 mr-6 mb-3"
                        @click="stop"
                    >
                        <svg
                            class="text-gray-500 w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75V4.75C16.0041 4.75 19.25 7.99594 19.25 12V12C19.25 16.0041 16.0041 19.25 12 19.25V19.25C7.99594 19.25 4.75 16.0041 4.75 12V12Z"
                            ></path>
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M9.75 9.75L14.25 14.25"
                            ></path>
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M14.25 9.75L9.75 14.25"
                            ></path>
                        </svg>
                    </button>

                    <div
                        class="mb-[env(safe-area-inset-bottom)] flex flex-1 flex-col gap-3 p-1 mt-3"
                    >
                        <a
                            class="truncate text-center text-md md:text-xl leading-6 md:text-right text-waheed text-black-two"
                            href="#top"
                        >
                            {{ article_headline }}
                        </a>
                        <div>
                            <vue-plyr
                                ref="plyr"
                                v-show="playing"
                                :options="options"
                            >
                                <audio controls playsinline>
                                    <source
                                        :src="article_audio.audio_url_path"
                                        type="audio/mpeg"
                                    />
                                </audio>
                            </vue-plyr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mounting-portal>
</template>

<script>
export default {
    props: {
        article_audio: {},
        article_headline: {},
        lite: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            playing: false,
            paused: false,
            playerLoaded: false,
            options: {
                settings: [],
                speed: {
                    selected: 1.1,
                    options: [0.5, 1, 1.1, 1.5, 2]
                }
            }
        };
    },
    methods: {
        play() {
            this.playing = true;
            this.$refs.plyr.player.play();

            if (!this.playerLoaded) {
                axios
                    .post("audio-article/play", {
                        article_audio_id: this.article_audio.id
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }

            this.playerLoaded = true;
        },
        stop() {
            this.playing = false;
            this.$refs.plyr.player.stop();
        },
        togglePlay() {
            this.playing ? this.stop() : this.play();
        }
    }
};
</script>
